import { type Action } from 'react-sweet-state';

import { type Product } from '../../../../common/types';
import { readRemoteActionsMetasFromLocalStorage } from '../../../remote-actions-localstore';
import { type RemoteActionsStoreState } from '../../index';

export const initStore =
	(): Action<RemoteActionsStoreState, { product: Product }> =>
	({ setState }, { product }) => {
		// TODO Async read from Localstorage.

		setState({
			meta: readRemoteActionsMetasFromLocalStorage(product),
			isLoaded: true,
			product,
		});
	};
